import { createCoreEntityAdapter } from "../../utils/core";
import { STORE_NAMES } from "../../constants";
import { INormalizedProviderProjectExport } from "./types";

export default createCoreEntityAdapter<INormalizedProviderProjectExport>(
  STORE_NAMES.PROJECT_PROVIDER_EXPORT
);
